(() => {
    angular
    .module('finance')
    .controller(
      'finance.views.curlecReceivablePayments',
      CurlecReceivablePaymentsController
    );

    CurlecReceivablePaymentsController.$inject = [
        '$scope',
        'moment',
        '$state',
        '$stateParams',
        '$timeout',
        'financeConstants',
        'abp.services.finance.curlec',
    ];

    function CurlecReceivablePaymentsController(
        $scope,
        moment,
        $state,
        $stateParams,
        $timeout,
        financeConsts,
        curlecSvc,
    ) {
        const vm = this;
        vm.loading = 0;
        vm.requestParams = new RequestParamsModel($stateParams);
        
        vm.curlecTransactionsGridOptions = {
            appScopeProvider: vm,
            paginationPageSizes: financeConsts.grid.defaultPageSizes,
            paginationPageSize: financeConsts.grid.defaultPageSize,
            paginationCurrentPage: 1,
            useExternalPagination: true,
            useExternalSorting: true,
            columnDefs: [
                {
                    displayName: App.localize('CurlecOrderId'),
                    field: 'orderId',
                    minWidth: 120,
                },
                {
                    displayName: App.localize('CurlecPaymentId'),
                    field: 'paymentId',
                    minWidth: 120,
                },
                {
                    displayName: App.localize('SystemPaymentNumbers'),
                    field: 'paymentNumbers',
                    minWidth: 200,
                    cellTemplate: 'paymentNumbersTemplate',
                },
                {
                    displayName: App.localize('Status'),
                    field: 'status',
                    minWidth: 100,
                    cellTemplate: 'statusTemplate',
                },
                {
                    displayName: App.localize('BillingAccounts'),
                    field: 'tenant',
                    minWidth: 120,
                },
                {
                    displayName: App.localize('CreationTime'),
                    enableSorting: false,
                    field: 'creationTime',
                    cellTemplate: 'creationTimeTemplate',
                    minWidth: 100,
                },
            ],
            onRegisterApi(gridApi) {
                $scope.gridApi = gridApi;
                $scope.gridApi.core.on.sortChanged($scope, (scope, callback) => {
                vm.requestParams.sorting =
                    callback.length && callback[0].field
                    ? `${callback[0].field} ${callback[0].sort.direction}`
                    : null;
                });
                gridApi.pagination.on.paginationChanged(
                    $scope,
                    App.setPagination(vm.requestParams, getCurlecTransactions)
                );
            },
            data: [],
        };

        vm.getCurlecTransactions = getCurlecTransactions;
        vm.getDateTimeString = getDateTimeString;

        init();

        function init() {
            getCurlecTransactions();
        }

        function RequestParamsModel(params) {
            this.orderId = params.orderId;
            this.paymentId = params.paymentId;
            this.tenantName = params.tenantName;
            this.paymentNumber = params.paymentNumber;

            this.skipCount = params.skipCount || 0;
            this.maxResultCount = params.maxResultCount || financeConsts.grid.defaultPageSize;
            this.sorting = params.sorting;

            this.toInputDto = () => {
                const input = $.extend({}, this);
                return input;
            };

            this.toStateParams = () => {
                const stateParams = {
                    orderId: this.orderId,
                    paymentId: this.paymentId,
                    tenantName: this.tenantName,
                    paymentNumber: this.paymentNumber,
                    skipCount: this.skipCount,
                    maxResultCount: this.maxResultCount,
                    sorting: this.sorting,
                };
                return stateParams;
            };
        }

        function registerStateParams() {
            $state.transitionTo($state.current, vm.requestParams.toStateParams(), {
                notify: false,
            });
        }

        function getCurlecTransactions() {
            registerStateParams();
            const input = vm.requestParams.toInputDto();

            vm.loading += 1;
            curlecSvc
                .getCurlecTransactions(input)
                .success((data) => {
                    vm.curlecTransactionsGridOptions.totalItems = data.totalCount;
                    vm.curlecTransactionsGridOptions.data = data.items;
                })
                .finally(() => {
                    vm.loading -= 1;
                });
        }

        function getDateTimeString(date, timeZoneId) {
            return App.getDateTimeString(date, timeZoneId);
        }
    }
})();